import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=6037ba8e&scoped=true"
import script from "./Withdraw.vue?vue&type=script&lang=ts"
export * from "./Withdraw.vue?vue&type=script&lang=ts"
import style0 from "./Withdraw.vue?vue&type=style&index=0&id=6037ba8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037ba8e",
  null
  
)

export default component.exports